import React, { useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ThankYou = () => {
    const navigate = useNavigate();
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const { name } = patientDetails || {};
    const [reload, setReload] = useState(true);

    // useEffect(() => {
    //     if (reload) {
    //         window.location.reload();
    //         setReload(false);
    //     }
    // }, [])
    return (
        <div style={{padding: '10%' }}>
            <Box >
                <Grid  className='App' style={{ marginTop: "20%" }}>
                    <Grid>
                        <div>
                            <Box>
                                <h2 className='lobyh2'>{`Thanks,\n${(name && name[0] && name[0]?.given && name[0]?.given[0]) || ''}!`}</h2>
                                <p className='lobyP'>{`Thanks for using Akos Urgent Care.`}</p>
                            </Box>
                            <Button style={{ width: '50%', backgroundColor: '#024C9C',fontFamily: 'Manrope', marginTop: '20%',borderRadius:'10px' }} size='large' variant="contained" onClick={(e) => { e.preventDefault(); navigate('/room/patient') }}>Back To Home</Button>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </div>
    )
}

export default ThankYou;
